import { PropsWithChildren } from 'react';
import { ResolveRoute, useResolveRoute } from '@mews/routing';
import {
    ContentContainer,
    LocalizedPageTitle,
    OptimusProvider,
    PortfolioLayout,
    PortfolioLayoutHeader,
} from '@mews-commander/ui';
import { TextKey, RouteName } from '@mews-commander/enums';
import { Substitutes } from '@mews/framework';
import { Container, Tabs } from '@optimus-web/core';
import { useTabsConfig } from '../../modalManager/tabs';

const getTabs = ({
    resolveRoute,
}: {
    resolveRoute: ResolveRoute;
}): Array<{ key: Mews.TextKey; substitutes?: Substitutes; url: string }> => [
    { key: TextKey.Profile, url: resolveRoute(RouteName.ProfileIndex) },
    { key: TextKey.Preferences, url: resolveRoute(RouteName.ProfilePreferences) },
    { key: TextKey.PrivacyAndSecurity, url: resolveRoute(RouteName.ProfileSecurity) },
];

export const SettingsLayout = ({
    activeTab,
    children,
    guideLink,
}: PropsWithChildren<{
    activeTab: Mews.TextKey;
    guideLink?: string;
}>) => {
    const resolveRoute = useResolveRoute();

    const tabsConfig = useTabsConfig({
        tabs: getTabs({ resolveRoute }),
        activeTab,
    });

    return (
        <OptimusProvider density="spacious">
            <PortfolioLayout>
                <PortfolioLayoutHeader title={<LocalizedPageTitle textKey={TextKey.Account} />} guideLink={guideLink} />

                <Tabs
                    activeTabValue={tabsConfig.activeTabValue}
                    onTabClick={tabsConfig.handleTabClick}
                    underline
                    inline
                    showDivider
                >
                    {tabsConfig.tabs}
                </Tabs>

                <Container padding={['200', '0', '0']}>
                    <ContentContainer condensed align="left" maxWidth="640px">
                        {children}
                    </ContentContainer>
                </Container>
            </PortfolioLayout>
        </OptimusProvider>
    );
};
